import Image from 'next/image'

import useSWR from 'swr'

import { ThemeRelatedStyleDocument } from '@/generated/contentful'

import { client } from '@/lib/contentful/client'
import { serializeCacheKey } from '@/lib/contentful/utils'

import { Link } from '@/components/CustomLink'

type Props = {
	relatedId: string | null
}

export const ThemeRelatedStyle = ({ relatedId }: Props) => {
	const { data } = useSWR(relatedId && serializeCacheKey('themeRelatedStyle', { relatedId }), () =>
		client().request(ThemeRelatedStyleDocument, {
			relatedId
		})
	)

	return (
		<Link href={`/theme/${data?.marketplaceThemeCollection?.items?.[0]?.slug}/`}>
			<div className="w-full h-[150px] relative">
				<Image
					src={data?.marketplaceThemeCollection?.items?.[0]?.largeThumbnail!}
					alt={data?.marketplaceThemeCollection?.items?.[0]?.title!}
					fill
					objectFit="cover"
				/>
			</div>
			<h3 className="text-sm mt-2">{data?.marketplaceThemeCollection?.items?.[0]?.title}</h3>
		</Link>
	)
}
